import { render } from "./deliveryService.vue?vue&type=template&id=0c5dee82"
import script from "./deliveryService.vue?vue&type=script&setup=true&lang=js"
export * from "./deliveryService.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/componentBase/AlbbPublishProduct/components/deliveryService.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c5dee82"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c5dee82', __exports__)) {
    api.reload('0c5dee82', __exports__)
  }
  
  module.hot.accept("./deliveryService.vue?vue&type=template&id=0c5dee82", () => {
    api.rerender('0c5dee82', render)
  })

}


export default __exports__